import { v4 } from 'uuid'

const Route = ({route, color, parent}) => {
	if (parent === undefined) {
		return (
			<>
				<line
					x1={route.from[0]}
					y1={route.from[1]}
					x2={route.to[0]}
					y2={route.to[1]}
					className={color + " " + route.marker}
				/>
				{
					route !== undefined ?
					route.children.map((c) => <Route
						key={ v4() }
						route={c}
						color={color}
						parent={ { from : route.from, to : route.to} }
					/>) : ""
				}
			</>
		)
	}

	const s =  route.position[0] - parent.from[0]
	const t =  route.position[1] - parent.from[1]
	const x =  parent.to[0] - parent.from[0]
	const y =  parent.to[1] - parent.from[1]
	const lambda = (x * s + y * t) / (x**2 + y**2)
	const fp = [x * lambda + parent.from[0], y * lambda + parent.from[1]]

	if (route.type === 'end') {
		return (
			<line
				x1={route.position[0]}
				y1={route.position[1]}
				x2={fp[0]}
				y2={fp[1]}
				className={route.marker + " " + color}
			/>
		)
	} else {
		return (
			<>
				<line
					x1={route.position[0]}
					y1={route.position[1]}
					x2={fp[0]}
					y2={fp[1]}
					className={route.marker + ' ' + color}
				/>
				{
				route.children.map((c) => <Route
					key={ v4() }
					route={c}
					color={color}
					parent={ { from : fp, to : route.position} }
				/>)
				}
			</>
		)
	}
}

export default Route
